const Logo = ({ width = 40, height = 40, className = '' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            {/* The Union Mark: Two interlocking shapes representing partnership */}
            <path
                d="M20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36V20H36C36 11.1634 28.8366 4 20 4Z"
                fill="#2F5C6E"
            />
            <path
                d="M20 36C28.8366 36 36 28.8366 36 20H20V36Z"
                fill="#D99B84"
            />
        </svg>
    );
};

export default Logo;
